import { render, staticRenderFns } from "./ArchivoEmpresa.vue?vue&type=template&id=8ed38204&scoped=true&"
import script from "./ArchivoEmpresa.vue?vue&type=script&lang=ts&"
export * from "./ArchivoEmpresa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed38204",
  null
  
)

export default component.exports